module.exports = __webpack_public_path__ + "img/8H.bbd90deb.jpg";